(() => {
  const MODAL_ID = 'reviews-plp-preview-modal';
  const WIDGET_SELECTOR = '#ReviewsWidgetPlpPreview';
  const STORE = 'www.smilodox.com';

  function getModal() {
    return document.getElementById(MODAL_ID);
  }

  function destroyWidget() {
    const container = document.querySelector(WIDGET_SELECTOR);
    if (container) container.innerHTML = '';
  }

  function buildWidgetOptions(productSKU, reviewsPerPage) {
    return {
      store: STORE,
      widget: 'polaris',
      options: {
        types: 'product_review',
        lang: 'de',
        layout: 'bordered,',
        per_page: reviewsPerPage,
        product_review: {
          sku: productSKU,
          hide_if_no_results: true,
        },
        header: {
          enable_summary: true,
          enable_ratings: true,
          enable_attributes: false,
          enable_image_gallery: false,
          enable_percent_recommended: false,
          enable_write_review: false,
          enable_ask_question: false,
          enable_sub_header: false,
          rating_decimal_places: 1,
        },
        filtering: {
          enable: false,
          enable_text_search: false,
          enable_sorting: false,
          enable_product_filter: false,
          enable_media_filter: false,
          enable_overall_rating_filter: false,
          enable_language_filter: false,
          enable_ratings_filters: false,
          enable_attributes_filters: false,
        },
        reviews: {
          enable_avatar: false,
          enable_reviewer_name: true,
          enable_reviewer_address: true,
          reviewer_address_format: 'country',
          enable_verified_badge: true,
          enable_subscriber_badge: true,
          enable_attributes: false,
          enable_product_name: false,
          enable_images: true,
          enable_ratings: true,
          enable_share: false,
          enable_helpful_vote: false,
          enable_helpful_display: false,
          enable_report: false,
          enable_date: true,
        },
      },
      translations: {
        'Verified Customer': 'Verifizierter Kauf',
      },
    };
  }

  async function openReviewsPreview(trigger) {
    const sku = trigger.dataset.reviewsSku;
    const modal = getModal();

    if (!modal || !sku) return;

    const titleEl = modal.querySelector('[data-reviews-plp-title]');
    const summaryEl = modal.querySelector('[data-reviews-plp-summary]');
    const loadingEl = modal.querySelector('[data-reviews-plp-loading]');
    const widgetHost = modal.querySelector('.reviews-plp-preview-modal__widget');

    if (titleEl) titleEl.textContent = trigger.dataset.reviewsTitle || '';
    if (summaryEl) {
      const rating = trigger.dataset.reviewsRating;
      const count = trigger.dataset.reviewsCount;
      summaryEl.textContent = rating && count ? `${rating} (${count})` : '';
    }

    destroyWidget();
    if (loadingEl) loadingEl.hidden = false;
    if (widgetHost) widgetHost.classList.remove('visible');

    modal.show();

    try {
      if (window.RO && typeof window.RO.loadReviewsIo === 'function') {
        await window.RO.loadReviewsIo();
      }

      if (typeof window.ReviewsWidget !== 'function') return;

      const reviewsPerPage = window.innerWidth < 768 ? 5 : 8;
      // eslint-disable-next-line no-new
      new window.ReviewsWidget(WIDGET_SELECTOR, buildWidgetOptions(sku, reviewsPerPage));

      if (widgetHost) widgetHost.classList.add('visible');
    } catch (error) {
      console.error('[reviews-plp-preview]', error);
    } finally {
      if (loadingEl) loadingEl.hidden = true;
    }
  }

  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest('[data-reviews-preview-trigger]');
      if (!trigger) return;

      event.preventDefault();
      event.stopPropagation();
      openReviewsPreview(trigger);
    },
    true
  );

  const modal = getModal();
  if (modal) {
    modal.addEventListener('dialog:after-hide', destroyWidget);
  }
})();
